<template>
    <div class="progress-container" v-show="loading">
        <el-progress 
            :percentage="percentage" 
            :show-text="false"
            :stroke-width="3"
            status="success"
            class="top-progress"/>
    </div>
    <router-view></router-view>
    <el-backtop class="custom-backtop" style="bottom: 30px;right: 30px;"/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getIpLocation } from '@/api/external/baiduMap';
export default {
    name: 'App',
    data(){
        return {
            loading: false,
            percentage: 0,
            timer: null,
        };
    },
    computed:{
        ...mapGetters('auth', ['getToken']),
        ...mapGetters('user', ['getUserId']),
        ...mapGetters(['getAddress','getIp']),
    },
    methods:{
        ...mapActions(['updateIp']),
        ...mapActions('websocket', ['connect', 'disconnect']),
        startProgress() {
            this.loading = true;
            this.percentage = 0;
            this.timer = setInterval(() => {
                if (this.percentage < 90) {
                    this.percentage += (90 - this.percentage) * 0.2;
                }
            }, 100);
        },
        finishProgress() {
            this.percentage = 100;
            setTimeout(() => {
                clearInterval(this.timer);
                this.loading = false;
                this.percentage = 0;
            }, 300);
        },
        async updateUserLocation() {
            this.updateIp('获取位置中...');
            try {
                const data = await getIpLocation();
                if (data.status) {
                    let location = '';
                    const province = data.province.replace('省', '');
                    const city = data.city.replace('市', '');
                    location = `${province} ${city}`;
                    this.updateIp(location);
                } else {
                    this.updateIp('无法获取位置');
                }
            } catch (error) {
                console.error('获取用户位置信息失败:', error);
                this.updateIp('无法获取位置');
            }
        }
    },
    async mounted() {
        await this.updateUserLocation();//获取用户位置信息
        // 应用启动时建立 WebSocket 连接
        if(this.getToken){
            await this.connect();
        }
        // 路由跳转开始时显示进度条
        this.$router.beforeEach((to, from, next) => {
            this.startProgress();
            next();
        });
        // 路由跳转完成时结束进度条
        this.$router.afterEach(() => {
            this.finishProgress();
        });
    },
    beforeUnmount() {
        // 应用关闭时断开连接
        this.disconnect();
    }
}
</script>

<style scoped>
.progress-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.top-progress {
    position: absolute;
    width: 100%;
}

:deep(.el-progress-bar__outer) {
    background-color: transparent !important;
}

:deep(.el-progress-bar__inner) {
    transition: all 0.2s linear;
    background-color: #1f628c !important;
}

.custom-backtop {
    background-color: #ffffff;
    width: 50px;
    height: 50px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgb(147, 147, 147);
}
</style>
